import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Chat from './components/Chat';
import './App.css';

// Direct Amplify configuration
const amplifyConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID || '',
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
  oauth: {
    domain: process.env.REACT_APP_COGNITO_DOMAIN || '',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN || 'http://localhost:3000/',
    redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT || 'http://localhost:3000/',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS'
};

// Configure AWS Amplify with error handling
try {
  // Validate required configuration
  if (!amplifyConfig.aws_user_pools_id) {
    throw new Error('REACT_APP_USER_POOL_ID is not configured');
  }
  if (!amplifyConfig.aws_user_pools_web_client_id) {
    throw new Error('REACT_APP_USER_POOL_CLIENT_ID is not configured');
  }
  if (!amplifyConfig.oauth.domain) {
    throw new Error('REACT_APP_COGNITO_DOMAIN is not configured');
  }
  
  Amplify.configure(amplifyConfig);
  console.log('Amplify configured successfully');
} catch (error) {
  console.error('Error configuring Amplify:', error);
  console.error('Please check your .env file and ensure all required environment variables are set.');
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route 
              path="/chat" 
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              } 
            />
            <Route path="/" element={<Navigate to="/chat" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
